//
// js-prefill-data-extractor.js - helper to extract data from data-store and insert it into the page
//
// kick-off                .js-prefill-data-extractor
//
// data-prefill-field      the name of the prefill item to get
// data-prefill-target     selector of element to act on
// data-prefill-property   "attribute" | "text"
// data-prefill-attribute  name of attribute (if data-property is "attribute")
// data-prefill-action     "insert" | "append"
// data-prefill-prepend    optional text to prepend to the prefill data retrieved before insertion
// data-prefill-append     ~ to append before insertion
//

import {data_store} from './data-store';


const required_attribs = [
  'data-prefill-field',
  'data-prefill-target',
  'data-prefill-property',
  'data-prefill-action',
];

function js_prefill_data_extractor(el) {
  const has_required_attribs = required_attribs.reduce((carry, att) => (carry && el.hasAttribute(att)), true);
  if (!has_required_attribs) {
    return;
  }

  const field_name = el.getAttribute('data-prefill-field');
  const target     = el.getAttribute('data-prefill-target');
  const property   = el.getAttribute('data-prefill-property');
  const action     = el.getAttribute('data-prefill-action');
  const prepend    = el.getAttribute('data-prefill-prepend') || '';
  const append     = el.getAttribute('data-prefill-append')  || '';


  let data_value = data_store().get(field_name);
  if (!data_value || !data_value.length) {
    return;
  }
  data_value = `${prepend}${data_value}${append}`;


  const target_element = document.querySelector(target);
  if (!target_element) {
    return;
  }


  if (property === 'attribute') { run__attribute(); }
  else if (property === 'text') { run__text();      }


  function run__attribute() {
    const attribute_name = el.getAttribute('data-prefill-attribute');
    if (!attribute_name) {
      return;
    }

    if (action === 'append') {
      const cur_value = target_element.getAttribute(attribute_name) || '';
      target_element.setAttribute(attribute_name, `${cur_value}${data_value}`);
    }
    else if (action === 'insert') {
      target_element.setAttribute(attribute_name, data_value);
    }
  }


  function run__text() {
    if (action === 'append') {
      target_element.textContent += data_value;
    }
    else if (action === 'insert') {
      target_element.textContent = data_value;
    }
  }
}


function init() {
  const items = Array.from(document.querySelectorAll('.js-prefill-data-extractor'));
  items.forEach(js_prefill_data_extractor);
}
init();

